
<template>
    <div id="modalleave" class="modal">
        <div class="modal-content">
            <h4><strong>Ne partez pas !</strong></h4>
            <p>
                De nos jours il est vraiment <strong>essentiel</strong> d'avoir un <strong>site internet moderne</strong>.<br>
                <strong>Faites-moi confiance</strong> et je réaliserais pour vous le <strong>site internet idéal</strong> !
            </p>
            <div class="center-align">
                <ctabutton class="modal-close"></ctabutton>
            </div>
        </div>
        <div class="modal-footer">
            <span class="modal-close waves-effect waves-green btn-flat">Fermer<i class="material-icons right">close</i></span>
        </div>
    </div>
</template>

<script>
import Ctabutton from './Ctabutton'

export default {
  name: 'Modalleave',
  components: {Ctabutton}
}
</script>

<style scoped>
strong {
    font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/Modalleave.vue